
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import { Language, Provider, TranslationService } from '../../global/models'
import { toTitleCase } from '../../global/functions/util'
import RelationshipDisplay from '../../relationships/components/RelationshipDisplay.vue'

@Component({
  components: { RelationshipDisplay }
})
export default class ProviderReadPage extends Vue {
  provider: Provider | null = null

  error: string | null = null

  supportedLanguages: Language[] = []

  get providerId() {
    return this.$route.params.id
  }

  mounted() {
    this.getData()
    this.getLanguages()
  }

  async getLanguages() {
    const response = await axios.get<Language[]>('languages')
    this.supportedLanguages = response.data
  }

  canCreateOffer(service: TranslationService) {
    return this.supportedLanguages.some(language => language.id === service.languageId)
  }

  relationshipStatus(service: TranslationService) {
    if (service.relationship) {
      return toTitleCase(service.relationship.status)
    }

    return null
  }

  relationshipStatusColour(service: TranslationService) {
    if (service.relationship) {
      return service.relationship.status === 'active' ? 'success' : 'error'
    }

    return null
  }

  async getData() {
    try {
      const response = await axios.get<Provider>(`/providers/${this.providerId}`)
      this.provider = response.data
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 404:
            this.error = 'not-found'
            break
          case 403:
            this.error = 'unauthorised'
            break
          default:
            this.error = 'generic'
        }
      } else {
        this.error = 'generic'
      }
    }
  }

  goToCreateOffer(service: TranslationService) {
    this.$router.push({ name: 'offers-create', query: { languageId: service.languageId.toString() } })
  }
}
